export default "__VITE_ASSET__ChhybN6C__"